import React from 'react';
import Contact from '../components/Contact/Contact';
import HoursOfOperation from '../components/HoursOfOperation/HoursOfOperation';
import StoreAddress from '../components/StoreAddress/StoreAddress';

const ContactPage = () => {
  return (
    <div className="main-content">
      <Contact />
      <StoreAddress />
      <HoursOfOperation />
      <div className="map">
        <h2>Find Us</h2>
        <iframe
          title="Burger Barn Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2967.479301875345!2d-111.3930977!3d41.947039!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x875413ad00015e9d%3A0x184709da57a9336!2sThe%20Burger%20Barn!5e0!3m2!1sen!2sus!4v1744168161673!5m2!1sen!2sus"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactPage;